import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
var _excluded = ["classes", "text"];
import React from 'react';
import PropTypes from 'prop-types';
import { default as withStyles } from '../styles';
import Typography from '../Typography';
import { spacing50, spacing60 } from '../styles/tokens';

var styles = function styles(theme) {
  return {
    h1: {
      marginTop: spacing60,
      marginBottom: spacing50
    }
  };
};
/**
 * Use `PageHeader` to display a page title at the top of a page.
 * @done true
 * @updated v3.3.0
 * @versionAdded v0.0.8
 * @examples
 *  PageHeaderExample
 */


var PageHeader = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var classes = props.classes,
      text = props.text,
      rest = _objectWithoutPropertiesLoose(props, _excluded);

  var classOverrides = _extends({
    h1: classes.h1
  }, classes);

  return /*#__PURE__*/React.createElement(Typography, _extends({}, rest, {
    classes: classOverrides,
    variant: "h1",
    ref: ref
  }), text);
});
PageHeader.muiName = 'PageHeader';
PageHeader.displayName = 'PageHeader';
PageHeader.propTypes = {
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,

  /**
   * The content to be displayed as the page header.
   */
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.node])
};
export default withStyles(styles)(PageHeader);